export interface MangaCategory {
  slug: string;
  name: string;
  description: string;
  icon: string;
  count: number;
}

export interface MangaItem {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  status: '连载中' | '已完结';
  rating: number;
  description: string;
  categories: string[];
  tags: string[];
  chapters: number;
  updatedAt: string;
  views: number;
}

export interface ReviewItem {
  id: string;
  userName: string;
  avatar: string;
  rating: number;
  content: string;
  mangaTitle: string;
  date: string;
}

export interface FaqItem {
  question: string;
  answer: string;
}

export const categories: MangaCategory[] = [
  { slug: 'romance', name: '恋爱漫画', description: '甜蜜浪漫的爱情故事', icon: 'ri-heart-line', count: 1280 },
  { slug: 'fantasy', name: '奇幻冒险', description: '异世界与魔法奇幻之旅', icon: 'ri-magic-line', count: 956 },
  { slug: 'action', name: '热血动作', description: '激烈打斗与热血剧情', icon: 'ri-fire-line', count: 843 },
  { slug: 'drama', name: '都市剧情', description: '现实向都市生活故事', icon: 'ri-building-line', count: 1120 },
  { slug: 'comedy', name: '搞笑日常', description: '轻松幽默的日常喜剧', icon: 'ri-emotion-laugh-line', count: 678 },
  { slug: 'thriller', name: '悬疑惊悚', description: '扣人心弦的悬疑故事', icon: 'ri-ghost-line', count: 534 },
  { slug: 'historical', name: '古风历史', description: '唯美古风历史题材', icon: 'ri-ancient-gate-line', count: 412 },
  { slug: 'bl', name: 'BL漫画', description: '唯美BL向作品精选', icon: 'ri-star-line', count: 890 },
];

export const hotMangas: MangaItem[] = [
  {
    id: '1',
    title: '我的野蛮王妃',
    author: '朴美珍',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%20art%20style%2C%20beautiful%20princess%20in%20traditional%20hanbok%2C%20soft%20pastel%20pink%20background%2C%20elegant%20portrait%2C%20webtoon%20illustration%20with%20delicate%20lineart%2C%20shoujo%20manga%20aesthetic%2C%20clean%20simple%20composition%2C%20romantic%20atmosphere&width=600&height=860&seq=manga-hot-01&orientation=portrait',
    status: '连载中',
    rating: 9.6,
    description: '现代女孩意外穿越到古代朝鲜王朝，成为高傲王世子妃，两人从互相看不顺眼到暗生情愫的浪漫故事。',
    categories: ['恋爱漫画', '古风历史'],
    tags: ['穿越', '宫廷', '甜宠', '欢喜冤家'],
    chapters: 89,
    updatedAt: '2026-07-06',
    views: 12580000,
  },
  {
    id: '2',
    title: '猎魔人传说',
    author: '金炫宇',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20fantasy%20cover%20art%2C%20demon%20hunter%20with%20sword%2C%20dark%20mysterious%20atmosphere%2C%20mint%20green%20accent%20background%2C%20webtoon%20style%20illustration%2C%20dynamic%20pose%2C%20clean%20composition%2C%20epic%20fantasy%20aesthetic&width=600&height=860&seq=manga-hot-02&orientation=portrait',
    status: '连载中',
    rating: 9.4,
    description: '拥有特殊能力的猎魔人金贤秀，在妖魔横行的现代都市中守护人类世界，一步步揭开身世之谜。',
    categories: ['奇幻冒险', '热血动作'],
    tags: ['战斗', '都市', '超能力', '悬疑'],
    chapters: 134,
    updatedAt: '2026-07-05',
    views: 9830000,
  },
  {
    id: '3',
    title: '办公室密恋',
    author: '李恩熙',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20office%20romance%20cover%20art%2C%20handsome%20CEO%20and%20female%20employee%2C%20modern%20office%20setting%2C%20warm%20soft%20lighting%2C%20webtoon%20illustration%20style%2C%20elegant%20couple%20portrait%2C%20clean%20simple%20background%2C%20romantic%20atmosphere&width=600&height=860&seq=manga-hot-03&orientation=portrait',
    status: '已完结',
    rating: 9.5,
    description: '职场新人林小鹿进入梦想公司，意外与冷面上司展开一段办公室地下恋情，甜蜜又刺激。',
    categories: ['恋爱漫画', '都市剧情'],
    tags: ['办公室', '姐弟恋', '甜宠', '治愈'],
    chapters: 67,
    updatedAt: '2026-06-28',
    views: 15600000,
  },
  {
    id: '4',
    title: '重生之豪门千金',
    author: '崔秀雅',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20cover%20art%2C%20elegant%20woman%20in%20luxury%20dress%2C%20wealthy%20family%20setting%2C%20warm%20golden%20yellow%20brown%20background%2C%20webtoon%20style%20illustration%2C%20sophisticated%20portrait%2C%20clean%20composition%2C%20dramatic%20atmosphere&width=600&height=860&seq=manga-hot-04&orientation=portrait',
    status: '连载中',
    rating: 9.3,
    description: '被陷害致死的豪门千金重生回到十年前，带着前世记忆步步为营，揭开惊天阴谋，逆天改命。',
    categories: ['都市剧情', '恋爱漫画'],
    tags: ['重生', '复仇', '豪门', '女强'],
    chapters: 102,
    updatedAt: '2026-07-06',
    views: 18700000,
  },
  {
    id: '5',
    title: '末日生存法则',
    author: '郑宇成',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20survival%20cover%20art%2C%20post%20apocalyptic%20scene%2C%20survivors%20in%20ruined%20city%2C%20dark%20dramatic%20atmosphere%2C%20webtoon%20illustration%20style%2C%20intense%20composition%2C%20clean%20lines%2C%20suspenseful%20mood&width=600&height=860&seq=manga-hot-05&orientation=portrait',
    status: '连载中',
    rating: 9.2,
    description: '丧尸病毒爆发后的首尔，一群普通人在末日绝境中挣扎求生，人性与兽性的终极考验。',
    categories: ['悬疑惊悚', '热血动作'],
    tags: ['末日', '丧尸', '生存', '人性'],
    chapters: 78,
    updatedAt: '2026-07-04',
    views: 11200000,
  },
  {
    id: '6',
    title: '仙尊归来',
    author: '韩志成',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20martial%20arts%20fantasy%20cover%20art%2C%20immortal%20cultivator%20in%20traditional%20robe%2C%20ancient%20Chinese%20inspired%20setting%2C%20soft%20gray%20ethereal%20background%2C%20webtoon%20illustration%20style%2C%20powerful%20aura%2C%20clean%20elegant%20composition&width=600&height=860&seq=manga-hot-06&orientation=portrait',
    status: '连载中',
    rating: 9.7,
    description: '修真界第一仙尊重生回到少年时代，带着万载记忆重新修炼，逆天崛起碾压一切强敌。',
    categories: ['奇幻冒险', '热血动作'],
    tags: ['修仙', '重生', '爽文', '逆袭'],
    chapters: 156,
    updatedAt: '2026-07-06',
    views: 22100000,
  },
  {
    id: '7',
    title: '甜蜜暴击',
    author: '安孝珍',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20romance%20cover%20art%2C%20cute%20couple%20in%20school%20uniform%2C%20bright%20cheerful%20pink%20coral%20background%2C%20webtoon%20style%20illustration%2C%20playful%20expression%2C%20clean%20simple%20composition%2C%20youthful%20energetic%20atmosphere&width=600&height=860&seq=manga-hot-07&orientation=portrait',
    status: '已完结',
    rating: 9.1,
    description: '跆拳道少女和学霸校草被迫成为同桌，从互怼到互宠的爆笑校园恋爱喜剧。',
    categories: ['恋爱漫画', '搞笑日常'],
    tags: ['校园', '甜宠', '搞笑', '青春'],
    chapters: 55,
    updatedAt: '2026-06-15',
    views: 8900000,
  },
  {
    id: '8',
    title: '暗夜追踪者',
    author: '朴志勋',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20mystery%20crime%20cover%20art%2C%20detective%20in%20dark%20alley%2C%20noir%20atmosphere%2C%20city%20night%20scene%2C%20webtoon%20illustration%20style%2C%20suspenseful%20composition%2C%20clean%20lines%2C%20thrilling%20mood&width=600&height=860&seq=manga-hot-08&orientation=portrait',
    status: '连载中',
    rating: 9.0,
    description: '天才侧写师与刑警队长联手追查连环杀人案，隐藏在暗处的真相远比想象的更加骇人。',
    categories: ['悬疑惊悚', '都市剧情'],
    tags: ['推理', '犯罪', '悬疑', '心理'],
    chapters: 63,
    updatedAt: '2026-07-03',
    views: 7600000,
  },
];

export const latestMangas: MangaItem[] = [
  {
    id: '9',
    title: '玫瑰与荆棘',
    author: '姜美娜',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20drama%20cover%2C%20woman%20holding%20red%20rose%2C%20elegant%20dark%20mood%2C%20webtoon%20illustration%20style%2C%20clean%20composition%2C%20dramatic%20romantic%20atmosphere&width=400&height=560&seq=manga-latest-01&orientation=portrait',
    status: '连载中',
    rating: 9.2,
    description: '为了给母亲治病而成为契约新娘的女主，与冷酷霸总之间纠缠不休的爱恨情仇。',
    categories: ['恋爱漫画', '都市剧情'],
    tags: ['契约', '虐恋', '总裁', '治愈'],
    chapters: 45,
    updatedAt: '2026-07-06',
    views: 4500000,
  },
  {
    id: '10',
    title: '武道至尊',
    author: '柳承浩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20martial%20arts%20action%20cover%2C%20fighter%20in%20dynamic%20pose%2C%20energy%20aura%2C%20webtoon%20illustration%20style%2C%20powerful%20atmosphere%2C%20clean%20composition&width=400&height=560&seq=manga-latest-02&orientation=portrait',
    status: '连载中',
    rating: 9.3,
    description: '被称为废材的少年意外获得远古武神传承，从此踏上碾压天才的武道巅峰之路。',
    categories: ['热血动作', '奇幻冒险'],
    tags: ['武道', '逆袭', '热血', '爽文'],
    chapters: 112,
    updatedAt: '2026-07-06',
    views: 9800000,
  },
  {
    id: '11',
    title: '恋爱细胞',
    author: '尹智恩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20slice%20of%20life%20romance%20cover%2C%20young%20couple%20in%20cafe%2C%20warm%20cozy%20atmosphere%2C%20webtoon%20illustration%20style%2C%20clean%20simple%20composition%2C%20heartwarming%20mood&width=400&height=560&seq=manga-latest-03&orientation=portrait',
    status: '连载中',
    rating: 8.9,
    description: '恋爱细胞为零的母胎单身女孩，在三个不同类型男生的追求下逐渐唤醒恋爱感知。',
    categories: ['恋爱漫画', '搞笑日常'],
    tags: ['母单', '多男主', '搞笑', '治愈'],
    chapters: 38,
    updatedAt: '2026-07-05',
    views: 3400000,
  },
  {
    id: '12',
    title: '魔王的契约新娘',
    author: '金荷娜',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20romance%20cover%2C%20demon%20king%20and%20bride%2C%20gothic%20fantasy%20setting%2C%20webtoon%20illustration%20style%2C%20mysterious%20atmosphere%2C%20clean%20elegant%20composition&width=400&height=560&seq=manga-latest-04&orientation=portrait',
    status: '连载中',
    rating: 9.4,
    description: '普通人类少女被选为魔界之王的契约新娘，在黑暗世界中寻找属于自己的幸福与力量。',
    categories: ['奇幻冒险', '恋爱漫画'],
    tags: ['魔幻', '契约', '暗黑', '甜宠'],
    chapters: 71,
    updatedAt: '2026-07-05',
    views: 6200000,
  },
  {
    id: '13',
    title: '我们的秘密花园',
    author: '张秀贤',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20BL%20romance%20cover%2C%20two%20handsome%20men%20in%20garden%2C%20soft%20romantic%20atmosphere%2C%20webtoon%20illustration%20style%2C%20clean%20beautiful%20composition%2C%20tender%20mood&width=400&height=560&seq=manga-latest-05&orientation=portrait',
    status: '连载中',
    rating: 9.5,
    description: '两个性格迥异的男人在共同打理一座秘密花园的过程中，悄然滋生了超越友谊的情感。',
    categories: ['BL漫画', '都市剧情'],
    tags: ['治愈', '慢热', '文艺', '温馨'],
    chapters: 52,
    updatedAt: '2026-07-04',
    views: 7800000,
  },
  {
    id: '14',
    title: '星际猎人',
    author: '吴泰俊',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20sci%20fi%20action%20cover%2C%20space%20hunter%20with%20futuristic%20gear%2C%20cosmic%20background%2C%20webtoon%20illustration%20style%2C%20dynamic%20composition%2C%20clean%20lines%2C%20epic%20atmosphere&width=400&height=560&seq=manga-latest-06&orientation=portrait',
    status: '连载中',
    rating: 9.1,
    description: '星际时代最年轻的S级猎人，穿梭于各个星球执行危险任务，揭开宇宙深处的神秘文明。',
    categories: ['奇幻冒险', '热血动作'],
    tags: ['科幻', '星际', '冒险', '战斗'],
    chapters: 95,
    updatedAt: '2026-07-03',
    views: 5400000,
  },
];

export const allMangas = [...hotMangas, ...latestMangas];

export const reviews: ReviewItem[] = [
  {
    id: 'r1',
    userName: '漫画迷小陈',
    avatar: 'https://readdy.ai/api/search-image?query=anime%20style%20young%20male%20avatar%20portrait%2C%20simple%20clean%20background%2C%20friendly%20expression%2C%20illustration&width=100&height=100&seq=avatar-user-01&orientation=squarish',
    rating: 5,
    content: '歪歪漫画的画质真的太棒了！高清无删减版看着就是过瘾，而且更新速度也很快，基本同步韩国那边，强烈推荐给所有韩漫爱好者！',
    mangaTitle: '仙尊归来',
    date: '2026-07-06',
  },
  {
    id: 'r2',
    userName: '甜宠控小鹿',
    avatar: 'https://readdy.ai/api/search-image?query=anime%20style%20young%20female%20avatar%20portrait%2C%20simple%20clean%20background%2C%20cute%20expression%2C%20illustration&width=100&height=100&seq=avatar-user-02&orientation=squarish',
    rating: 5,
    content: '在这里追了好多韩漫了，分类特别细，找漫画超方便。特别是恋爱分类里的作品都好甜，每天都要来看看有没有更新！',
    mangaTitle: '办公室密恋',
    date: '2026-07-05',
  },
  {
    id: 'r3',
    userName: '热血少年阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=anime%20style%20teen%20male%20avatar%20portrait%2C%20simple%20clean%20background%2C%20cool%20expression%2C%20illustration&width=100&height=100&seq=avatar-user-03&orientation=squarish',
    rating: 4,
    content: '打斗漫画的画风超燃！分镜处理得很到位，看起来特别带感。而且翻译质量也很好，完全没有机翻的生硬感。',
    mangaTitle: '武道至尊',
    date: '2026-07-04',
  },
];

export const faqs: FaqItem[] = [
  {
    question: '歪歪漫画网的漫画都是免费的吗？',
    answer: '是的，歪歪漫画网所有韩国漫画均为免费在线阅读，无需任何付费即可畅享全部内容。我们致力于为韩漫爱好者提供最优质的免费阅读体验，每周持续更新最新章节。',
  },
  {
    question: '漫画是否高清无删减？',
    answer: '我们保证所有漫画均为高清原版画质，内容无删减，完整呈现韩国原作者的原汁原味创作。每一话都经过精心处理，确保读者获得最佳阅读体验。',
  },
  {
    question: '多久更新一次漫画内容？',
    answer: '我们每天都会更新漫画内容，热门连载作品基本与韩国同步更新。通常国内更新时间在韩国发布后的24小时内完成翻译和上架，让您第一时间看到最新章节。',
  },
  {
    question: '如何找到我想看的漫画？',
    answer: '您可以通过首页的分类导航按类型筛选，也可以使用搜索功能输入漫画名称或作者来快速查找。此外，热门推荐区和最新更新区也会帮助您发现优质作品。',
  },
  {
    question: '支持手机阅读吗？',
    answer: '当然支持！歪歪漫画网采用响应式设计，完美适配手机、平板和电脑等多种设备。无论您使用什么设备，都能获得流畅舒适的阅读体验。',
  },
  {
    question: '可以在歪歪漫画网上投稿原创漫画吗？',
    answer: '目前我们主要专注于韩国漫画的引进和翻译，暂未开放原创投稿渠道。如果您是漫画作者并有合作意向，欢迎通过"关于我们"页面的联系方式与我们取得联系。',
  },
];

export const statsData = [
  { label: '漫画作品', value: '12,800+', icon: 'ri-book-open-line' },
  { label: '累计用户', value: '5,600,000+', icon: 'ri-user-line' },
  { label: '日均更新', value: '200+', icon: 'ri-timer-flash-line' },
  { label: '用户好评率', value: '98.6%', icon: 'ri-thumb-up-line' },
];